import { LightningElement } from 'lwc';

export default class GetWetHelpCenter extends LightningElement {
    issueOptions = [
        {label: 'Select an issue', value: ''},
        {label: 'Booking or reservation problem', value: 'booking'},
        {label: 'Payment or refund question', value: 'payment'},
        {label: 'Listing or host issue', value: 'listing'},
        {label: 'Account or login problem', value: 'account'},
        {label: 'Safety or property concern', value: 'safety'},
        {label: 'Something else', value: 'other'}
    ];

    form = {
        category: '',
        uncategorizedIssue: '',
        description: ''
    };

    handleFieldChange(event) {
        const field = event.currentTarget?.dataset?.field;
        if (!field) return;

        this.form = {
            ...this.form,
            [field]: event.target.value
        };
    }

    handleSubmit(event) {
        event.preventDefault();
        this.template.querySelector('[data-id="helpCenterForm"]')?.reset();
        this.form = {
            category: '',
            uncategorizedIssue: '',
            description: ''
        };
        this.showToast(
            'Issue succesfully submitted',
            "We will get back to you as soon as possible, if you don't hear back in 3 days email us at getwetinc777@gmail.com",
            'success'
        );
    }

    toastObj;
    showToast(title, message, variant, mode=null) {
        const modeP = mode
            ? mode
            : variant === 'success'
                ? 'dismissible'
                : 'sticky';

        this.toastObj = {
            variant,
            mode: modeP,
            message,
            header: {
                text: title
            }
        };
    }
}
